<template>
  <v-row class="filter-box my-0" data-id-e2e="displayGroupFilterSelect">
    <v-col cols="3" class="ps-0">
      {{ t('workpackagePage.splitWorkpackages.filterDisplayGroups') }}
    </v-col>
    <v-select
      v-model="selectedDisplayGroups"
      :items="displayGroups"
      item-value="_id"
      hide-details
      item-title=""
      white
      multiple
      :disabled="!displayGroups.length"
      :placeholder="t('filterWorkpackagesOptions.noOption')"
      class="rtls-select rtls-select--white"
      data-id-e2e="displayGroupSelect"
      @update:model-value="updateMainFilterObject()"
    >
      <template #selection="{ item, index }">
        <span v-if="index < 1" class="selected-items">{{ item.title }} &nbsp;</span>
        <span v-if="index === 1" class="text-grey text-caption">
          (+{{ displayGroups.length - 1 }}
          {{ t('workpackagePage.splitWorkpackages.moreDisplayGroups') }})
        </span>
      </template>
      <template #prepend-item>
        <div class="sticky">
          <div class="d-flex justify-space-around align-center pt-2">
            <v-btn class="button-link" variant="text" @click="selectAll">
              <v-icon size="16"> mdi-check </v-icon>
              <span>{{ t('actions.selectAll') }}</span>
            </v-btn>
            <v-btn class="button-link" variant="text" @click="selectNone">
              <v-icon size="16"> mdi-checkbox-blank-outline </v-icon>
              <span>{{ t('actions.selectNone') }}</span>
            </v-btn>
          </div>
          <v-divider class="mt-2" />
        </div>
      </template>
    </v-select>
  </v-row>
</template>

<script>
import { nextTick } from 'vue';
import { useInternationalization } from '@/composables/use-internationalization';
import { mapState } from 'pinia';
import { map, compact, uniq } from 'lodash';

// enums
import filterTypeEnum from '@enums/wp-filter-types';

// stores
import { useWorkpackageProductsStore } from '@/stores/workpackage-products';

export default {
  props: {
    products: {
      type: Array,
      required: true,
    },
  },

  setup() {
    const { t } = useInternationalization();
    return { t };
  },

  data: () => ({ selectedDisplayGroups: [] }),

  computed: {
    ...mapState(useWorkpackageProductsStore, ['workpackageProducts']),
    // Remove all undefined or falsy values, sort and just pluck the isDisplayable field
    displayGroups() {
      if (this.products.length > 0) {
        return uniq(compact(map(this.products, 'isDisplayable'))).sort();
      }
      return [];
    },
  },

  watch: {
    // When the products change, we should select all by default.
    products() {
      nextTick(() => {
        this.selectAll();
        this.$emit('updateMainFilterObject', {
          type: filterTypeEnum.displayGroup,
          update: this.selectedDisplayGroups,
          isInit: true,
        });
      });
    },
  },

  methods: {
    async updateMainFilterObject() {
      this.$emit('updateMainFilterObject', {
        type: filterTypeEnum.displayGroup,
        update: this.selectedDisplayGroups,
      });
    },

    selectAll() {
      this.selectedDisplayGroups = [...this.displayGroups];
    },

    selectNone() {
      this.selectedDisplayGroups = [];
      this.updateMainFilterObject();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';

:deep(.v-select__selections) {
  text-overflow: ellipsis;
  word-wrap: break-word;
  overflow: none;
}
:deep(.v-list) {
  position: relative;
}
.filter-box {
  align-items: center;

  span {
    padding-left: 0;
  }
}

.selected-items {
  padding-left: 5px !important;
}

.sticky {
  position: sticky;
  background-color: $canvas-header-white-background;
  top: 0;
}

.button-link {
  color: $assortment-primary-colour;
  padding: 0 !important;
  &::before,
  &::after {
    display: none !important;
  }

  span {
    text-decoration: underline;
  }
}
</style>
